import keyMirror from 'keymirror';

export const ACCESSIBILITY_PROFILE_STATUSES = keyMirror({
    CREATE: null,
    CREATED: null,
    EDIT: null,
    VIEW: null,
});

export const ACCESSIBILITY_PROFILE_STEPS = {
    PERSONAL_DETAILS: {
        index: 0,
        title: 'Personal Details',
    },
    ASSISTANCE_POINT: {
        index: 1,
        title: 'Assistance Point',
    },
    REASON_FOR_ASSISTANCE: {
        index: 2,
        title: 'Reasons for assistance',
    },
    CONTACT_PREFERENCES: {
        index: 3,
        title: 'Contact preferences',
    },
    SUMMARY: {
        index: 4,
        title: 'Summary',
    },
};

export const BOOK_PA_STEPS = {
    PERSONAL_DETAILS: {
        index: 0,
        title: 'Personal Details',
    },
    WHEN: {
        index: 1,
        title: 'When',
    },
    TRAIN: {
        index: 2,
        title: 'Train',
    },
    RETURN: {
        index: 3,
        title: 'Return',
    },
    PREFERENCES: {
        index: 4,
        title: 'Preferences',
    },
    SUMMARY: {
        index: 5,
        title: 'Summary',
    },
};

export const BOOK_PA_RETURN_JOURNEY_STEPS = {
    QUESTION: 0,
    WHEN: 1,
    TRAIN: 2,
};

export const assistanceLocationConfig = [
    {
        label: 'All points (change of train is required)',
        value: 'all_points'
    },
    {
        label: 'Arrival station',
        value: 'arrival_station_only'
    },
    {
        label: 'Departure station',
        value: 'departure_station_only'
    },
    {
        label: 'Other',
        value: 'other'
    }
];

export const assistanceLocationOther = 'other';

export const assistanceReasons = {
    VISUALLY_IMPAIRED: {
        label: 'Visually Impaired',
        value: 'Visually Impaired'
    },
    ELDERLY: {
        label: 'Older Person',
        value: 'Elderly'
    },
    HEARING_IMPAIRED: {
        label: 'Hearing Impaired',
        value: 'Hearing Impaired'
    },
    LEARNING_DISABILITY: {
        label: 'Learning Disability',
        value: 'Learning Disability'
    },
    VERBALLY_IMPAIRED: {
        label: 'Verbally Impaired',
        value: 'Verbally Impaired'
    },
    OWN_WHEELCHAIR_USER: {
        label: 'Own Wheelchair User - help with transfer to seat',
        value: 'Own Wheelchair User - help with transfer to seat'
    },
    STATION_WHEELCHAIR_USER: {
        label: 'Station Wheelchair User - help with transfer to seat',
        value: 'Station Wheelchair User - help with transfer to seat'
    },
    PERMANENT_WHEELCHAIR_USER: {
        label: 'Permanent Wheelchair User',
        value: 'Permanent Wheelchair User'
    },
    SCOOTER_USER: {
        label: 'Scooter User',
        value: 'Scooter User'
    },
    MOBILITY_IMPAIRED_NO_RAMP: {
        label: 'Mobility Impaired - no ramp',
        value: 'Mobility Impaired - no ramp'
    },
    MOBILITY_IMPAIRED_WITH_RAMP: {
        label: 'Mobility Impaired - ramp needed',
        value: 'Mobility Impaired - ramp needed'
    },
    OTHER_PHYSICAL_CONDITION: {
        label: 'Other Physical Condition',
        value: 'Other Physical Condition'
    },
    OTHER: {
        label: 'Other',
        value: 'Other'
    },
};

export const BOOKING_PA_PREFERENCES = [
    {
        question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.1',
        positiveAnswerLabel: 'Yes',
        negativeAnswerLabel: 'No',
        formKey: 'participateSurvey',
    },
    {
        question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.2',
        positiveAnswerLabel: 'Yes',
        negativeAnswerLabel: 'No',
        formKey: 'pushNotify',
    },
    {
        question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.3',
        positiveAnswerLabel: 'Yes',
        negativeAnswerLabel: 'No',
        formKey: 'participateImprovementSurvey',
    },
];

export const CREATING_AP_PREFERENCES = [
    {
        question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.1',
        positiveAnswerLabel: 'Yes',
        negativeAnswerLabel: 'No',
        formKey: 'participateSurvey',
    },
    {
        question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.2',
        positiveAnswerLabel: 'Yes',
        negativeAnswerLabel: 'No',
        formKey: 'pushNotify',
    },
];


export const CREATE_ACCESSIBILITY_PROFILE_ADDRESS = 'CREATE_ACCESSIBILITY_PROFILE_ADDRESS';

export const BOOKING_PA_STATUSES = keyMirror({
    BOOK_OUTWARD_JOURNEY: null,
    BOOK_RETURN_JOURNEY: null,
    EDIT_OUTWARD_JOURNEY: null,
    EDIT_RETURN_JOURNEY: null,
    CREATED: null,
    VIEW: null,
});

export const ASSIST_REQUEST_STATUS = {
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    PENDING: 'Pending',
};

export const EDIT_PA_SECTION_INDEXES = {
    PERSONAL_DETAILS: 0,
    ASSISTANCE_POINT: 1,
    REASON_FOR_ASSISTANCE: 2,
    CONTACT_PREFERENCES: 3,
    OUTWARD_JOURNEY: 4,
    RETURN_JOURNEY: 5,
};

export const EDIT_PA_SECTION_NAMES = [
    'personal-details',
    'assistance-point',
    'reason-for-assistance',
    'contact-preferences',
    'outward-journey',
    'return-journey'
];

export const CONTACT_METHODS = {
    email: 'Email',
    phone: 'Phone',
};

export const MULTI_LEGS_TYPE = keyMirror({
    HIDE: null,
    MORE_DETAILS_BUTTON: null,
    EXPANDED: null,
});



// WEBPACK FOOTER //
// ./src/components/account/passengerAssist/constants.js